import { render, staticRenderFns } from "./InvoiveAddress.vue?vue&type=template&id=4f9b645e&scoped=true&"
import script from "./InvoiveAddress.vue?vue&type=script&lang=js&"
export * from "./InvoiveAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9b645e",
  null
  
)

export default component.exports